var _effectorFileName = "/builds/gmini/front-ui-kit/src/TreeLoader/TreeLoader.tsx";
import { EllipseLoader } from '../icons';
import { LoaderText, LoaderWrapper, Backdrop } from './TreeLoader.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TreeLoader = ({
  loading,
  text
}) => loading ? /*#__PURE__*/_jsx(Backdrop, {
  children: /*#__PURE__*/_jsxs(LoaderWrapper, {
    children: [/*#__PURE__*/_jsx(EllipseLoader, {}), /*#__PURE__*/_jsx(LoaderText, {
      children: text
    })]
  })
}) : null;